// /login — вход; next — куда вернуть после входа (только путь внутри сервиса).
import { createFileRoute } from '@tanstack/react-router';
import { LoginPage } from '../features/auth/LoginPage.tsx';

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): { next?: string } =>
    typeof search.next === 'string' ? { next: search.next } : {},
  component: LoginRoute,
});

function LoginRoute() {
  const { next } = Route.useSearch();
  return <LoginPage next={next} />;
}
